// --------------------------------------------------------------------------
// Generic modal used across the site
// --------------------------------------------------------------------------
// Author:      Sarah Blount
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------
//
/*
    Trigger button must be given the class name 'info'
*/

'use strict';

var $ = require('jquery');
var postal = require('postal');
var channel = postal.channel('modals');
var reinitModules = require('../utilities/reinit-modules');

module.exports = function () {
    var closeModalButton = '<button class="close-button"><span class="button__text">Close</span></button>';
    var staticClass = 'is-static';
    var visibleClass = 'is-visible';
    var existingNames = [];

    /**
     * Hides internal modal from view
     */
    function hideInternalModal(overlay) {
        overlay.removeClass(visibleClass);
        overlay.prev().removeClass(staticClass);
    }

    /**
     * Shows internal modal
     */
    function showInternalModal(trigger) {
        if (!trigger.parent().is('.no-overlay')) {
            trigger.next().addClass(visibleClass);
            trigger.addClass(staticClass);
        }
    }

    /**
     * Creates an instance of the external modal
     */
    function createExternalModal(context, content, name) {
        return context.each(function (index) {
            // var content = content[index];
            if (name.indexOf(existingNames)) {
                index++;
            }

            if (typeof content === 'undefined') {
                content = $(this).find('.overlay');
            }

            if (!$(this).is('.no-overlay')) {

                $(this).attr('data-index', index);
                var thisModal = content;

                var thisModalNew = thisModal.clone();
                var thisModalWrap = null;

                //create & populate modal
                thisModalWrap = $('<div class="modal"><div class="inner-wrapper"></div></div>').appendTo('body');
                thisModalWrap.addClass(name + '--' + index);

                var thisModalInner = thisModalWrap.find('.inner-wrapper');

                thisModalNew.appendTo(thisModalInner);

                // Look for a close button in DOM
                var closeButton = thisModalWrap.find('.close-button');

                /// If there is no close button found, add a default
                if (closeButton.length === 0) {
                    thisModalInner.append(closeModalButton);
                }
            }
        });
    }

    /**
     * Set up external modal - puts content outside its context and appends it to the body
     */
    function externalModal(context, content, name) {

        // Init external modal
        // $.each()
        existingNames.push(name);
        createExternalModal(context, content, name);

        // if mask deosn't exist already
        var mask;

        if ($('.modal__mask').length === 0) {
            mask = $('<div class="modal__mask"></div>');
        } else {
            mask = $('.modal__mask');
        }
        mask.appendTo('body');

        // Show modal on click of item
        context.find('.info').on('click', function (e) {
            e.preventDefault();

            var modalIndex = context.data('index');

            //position
            if (!$(this).parent().is('.no-overlay')) {
                var $thisModal = $('.' + name + '--' + modalIndex);
                var scrollPos = $(window).scrollTop();
                var modalHeight = $thisModal.outerHeight();
                var modalPos = scrollPos + $(window).height() / 2 - modalHeight / 2;

                $thisModal.css({ 'top': modalPos }).addClass(visibleClass);

                $('.modal__mask').show();

                channel.publish('modal-open', { modal: $thisModal });

                if ($thisModal.is('[class*="reward"]')) {
                    var modules = [{
                        name: 'social-reward-modal',
                        module: require('./rewarding/social-reward-modal')
                    }];

                    reinitModules(modules);
                }
            }
        });

        // Hide modal on close button
        $('.modal .close-button').on('click', function () {
            $(this).parents('.modal').removeClass(visibleClass);
            $('.modal__mask').hide();
        });
    }

    /**
     * Set up internal modal - puts content in overlay directly where it is called
     */
    function internalModal(context) {

        // Look for a close button in DOM
        var closeButton = context.find('.close-button');

        /// If there is no close button found, add a default
        if (closeButton.length === 0) {
            context.find('.overlay').append(closeModalButton);
        }

        /// Show modal on click of item
        context.find('.info').on('click', function (e) {
            if (!$(this).parent().is('.no-overlay')) {
                e.preventDefault();
                showInternalModal($(this));
                console.log($(this));
            }
        });

        // Show modal on focus of item
        context.on({
            focus: function focus() {
                showInternalModal($(this).find('.info'));
            }
        });

        // Hide modal on close button
        context.find('.close-button').on({
            click: function click(e) {
                e.preventDefault();
                hideInternalModal($(this).parent());
            },
            focus: function focus() {
                hideInternalModal($(this).parent());
            }
        });
    }

    /**
     * Destroys external modal
     */
    function destroyExternalModal(context) {
        context.removeAttr('data-index');
        $('.modal').add('.modal__mask').remove();
        context.find('.info').unbind('click');
    }

    /**
     * Destroys internal modal
     */
    function destroyInternalModal(context) {
        context.find('.overlay').removeClass(visibleClass);
        context.find('.info').removeClass(staticClass);
        context.find('.info').unbind('click');
        context.unbind('focus');
    }

    /**
     * Make functions accessible to other modules
     */
    return {
        internalModal: internalModal,
        externalModal: externalModal,
        destroyExternalModal: destroyExternalModal,
        destroyInternalModal: destroyInternalModal
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/modal.js
// module id = 21
// module chunks = 0